import type { UndecoratedLead } from '@witmetrics/utils';
import { searchLeads } from '@/utils/filters';

export const classes = {
  listWrapper: 'mt-2',
  listTitle:
    'px-2 py-2 font-semibold tracking-wide text-grey-8 dark:text-mauve-1 text-sm',
  list: 'h-[40vh] overflow-auto',
  searchField: 'mt-[-0.75rem]',
  message: 'text-center text-grey-7 dark:text-mauve-2 mt-4',
};

export async function fetchMatchingLeads(
  search: string
): Promise<{ timestamp: number; leads: UndecoratedLead[] }> {
  const timestamp = Date.now();
  const results = await searchLeads(search, 25);
  return {
    timestamp,
    leads: results.map(({ phoneValue, ...r }) => r),
  };
}
